<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name {{ keyName }}
      span.validation-label(v-if="required == true") 必須

    .register-value
      // male
      label.register-radio-label
        input.register-radio-form(:id="'male-' + idPrefix" v-model="_value" type="radio" value="男性")
        span.register-radio-text 男性
      // female
      label.register-radio-label
        input.register-radio-form(:id="'female-' + idPrefix" v-model="_value" type="radio" value="女性")
        span.register-radio-text 女性
      // none
      label.register-radio-label
        input.register-radio-form(:id="'none-' + idPrefix" v-model="_value" type="radio" value="無回答")
        span.register-radio-text 無回答
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * 入力要素コンポーネント(性別)
 *
 * - 性別の入力をサポートする
 * - 既存の入力画面のスタイルが適用される
 */
@Component
export default class FormInputGender extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ type: String })
  private value!: string;

  /** 項目名 */
  @Prop({ required: true, type: String })
  private keyName!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  private required!: boolean;

  /** 本コンポーネントを1画面に複数配置した場合に必要なid属性用prefix */
  @Prop({
    default: () => {
      return "";
    }
  })
  private idPrefix!: string;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): string {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: string) {
    this.$emit("input", newValue);
    return;
  }
}
</script>
